module.exports = __webpack_public_path__ + "static/img/banner_医院AI审核.626ddd29.png";